export enum PAGE_SLUG {
    FAI_HOME = 'offres-internet',
    ELIGIBILITY = 'offres-internet_test-eligibilite',
    PACK = 'offres-internet_combo-box',
    PACK_GAMING = 'offres-internet_bbox-gaming',
    PACK_GAMING_PS5 = 'offres-internet_bbox-gaming-ps5',
    PACK_SMART_TV = 'offres-internet_bbox-smart-tv',
    PACK_TABLET = 'offres-internet_bbox-tablette',
    BIG_HOME = 'offres-box-forfait',
    PHONE_WALL = 'telephones-mobiles',
    PHONE_WALL_RENEWAL = 'telephones-mobiles_renouvellement',
    ACCESSORY_WALL = 'accessoires',
    PHONE_PRODUCT = 'telephones-mobiles_produit',
    ACCESSORY_PRODUCT = 'accessoires_produit',
    OFFER_WALL = 'forfaits-mobiles_avec-engagement',
    OFFER_WALL_RENEWAL = 'forfaits-mobiles_avec-engagement_renouvellement',
    CROSS_SELL = 'personnaliser-mon-offre',
    INTEREST_FORM = 'prise-interet',
    RECALL = 'rappelez-moi',
}

export type FaqSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.PACK_GAMING
    | PAGE_SLUG.PACK_GAMING_PS5
    | PAGE_SLUG.PACK_SMART_TV
    | PAGE_SLUG.PACK_TABLET
    | PAGE_SLUG.BIG_HOME;

export type LegalsSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.ELIGIBILITY // Post eligibility
    | PAGE_SLUG.PACK
    | PAGE_SLUG.BIG_HOME
    | PAGE_SLUG.PHONE_WALL
    | PAGE_SLUG.ACCESSORY_WALL
    | PAGE_SLUG.PHONE_PRODUCT
    | PAGE_SLUG.ACCESSORY_PRODUCT
    | PAGE_SLUG.OFFER_WALL
    | PAGE_SLUG.OFFER_WALL_RENEWAL
    | PAGE_SLUG.RECALL;

export type BannerSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.ELIGIBILITY
    | PAGE_SLUG.PACK
    | PAGE_SLUG.BIG_HOME
    | PAGE_SLUG.PHONE_WALL
    | PAGE_SLUG.PHONE_WALL_RENEWAL
    | PAGE_SLUG.ACCESSORY_WALL
    | PAGE_SLUG.CROSS_SELL
    | PAGE_SLUG.INTEREST_FORM
    | PAGE_SLUG.RECALL;

export const partials = {
    MARKETING: {
        ELIGIBILITY_26_YEAR_OLD: '/partials/fai/post-elig-bts-26',
        ELIGIBILITY_FTTH: '/partials/fai/post-elig-emerch-ftth',
        ELIGIBILITY_PACK: '/partials/fai/offres-pack',
        FAI_ANIMCO: '/partials/fai/animcocarte',
        FAI_BOTTOM_CONTENT: '/partials/mobiles/sas/contenu',
        FAI_COMMITMENTS: '/partials/fai/engagements',
        FAI_CONTENT: '/partials/fai/contenu',
        FAI_HOME_SLIDER: '/partials/banners/Home-fai_slider',
        FAI_PACK: '/partials/fai/animco-pack',
        FAI_WIFI: '/partials/fai/wifi-num-1',
        FAI_PERFORMANCE: '/partials/data-performance-fai',
        OFFER_WALL_SLIDER: '/partials/banners/Home-mobile_slider',
        PACK_TABLET: '/partials/ec/zone_panier_bbox_tablette',
        PLAN_EUROPE: '/partials/mobiles/banniere_forfaits-mobiles_destinations_europe',
        PLAN_INTERNATIONAL: '/partials/mobiles/banniere_forfaits-mobiles_destinations',
        PROMO_INFOGRAPHIE: '/partials/mixte/infographie-top',
        PROMO_PRESENTATION: '/partials/mixte/presentation-top',
        PROMO_STORYTELLING: '/partials/mixte/presentation-storytelling',
        KIDS_WATCH: '/partials/mobiles/kidswatch',
    },
    SEO: {
        PHONE_SEARCH_MDT: '/partials/mobiles/seo-recherche-mobile',
    },
    FAQ: (slug: FaqSlugType) => `/partials/faq/emplacements/${slug}`,
    BANNER: (slug: BannerSlugType) => `/partials/bandeau/${slug}`,
    LEGALS: (slug: LegalsSlugType) => `/partials/mentions_legales/emplacements/${slug}`,
    HEADER: {
        ACQ: '/partials/v3/header/index/needsupport',
        RNW: '/partials/v3/header/primary',
        LIGHT: '/partials/v3/header/light/needsupport',
    },
    FOOTER: {
        ACQ: '/partials/v3/footer',
        LIGHT: '/partials/v3/footer/light',
    },
};
